import {Specialty} from '../app/shared/models/lookup-profession.model';

const mockSpecialties: Specialty[] = [{
  id: 3,
  name: `Administrative`,
  abbreviation: `ADMIN`,
  professionIds: [1, 2, 5, 55],
  specialtyRelatedSpecialties: []
}, {
  id: 8,
  name: `CVICU`,
  abbreviation: `CVICU`,
  professionIds: [5, 2, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 8,
    relatedSpecialtyId: 276
  }, {
    specialtyId: 8,
    relatedSpecialtyId: 314
  }]
}, {
  id: 9,
  name: `Case Manager`,
  abbreviation: `CASEMGR`,
  professionIds: [1, 2, 5, 23],
  specialtyRelatedSpecialties: [{
    specialtyId: 9,
    relatedSpecialtyId: 264
  }]
}, {
  id: 16,
  name: `ICU`,
  abbreviation: `ICU`,
  professionIds: [5, 2, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 16,
    relatedSpecialtyId: 86
  }, {
    specialtyId: 16,
    relatedSpecialtyId: 275
  }, {
    specialtyId: 16,
    relatedSpecialtyId: 276
  }, {
    specialtyId: 16,
    relatedSpecialtyId: 277
  }, {
    specialtyId: 16,
    relatedSpecialtyId: 292
  }, {
    specialtyId: 16,
    relatedSpecialtyId: 315
  }]
}, {
  id: 19,
  name: `Dialysis`,
  abbreviation: `DIAL`,
  professionIds: [1, 2, 5],
  specialtyRelatedSpecialties: [{
    specialtyId: 19,
    relatedSpecialtyId: 259
  }]
}, {
  id: 22,
  name: `ER`,
  abbreviation: `ER`,
  professionIds: [5, 2, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 22,
    relatedSpecialtyId: 236
  }, {
    specialtyId: 22,
    relatedSpecialtyId: 239
  }, {
    specialtyId: 22,
    relatedSpecialtyId: 311
  }]
}, {
  id: 23,
  name: `EMT`,
  abbreviation: `EMT`,
  professionIds: [22],
  specialtyRelatedSpecialties: []
}, {
  id: 30,
  name: `Home Health`,
  abbreviation: `HH`,
  professionIds: [1, 2, 5, 15, 16, 17, 25, 26],
  specialtyRelatedSpecialties: []
}, {
  id: 35,
  name: `Labor and Delivery`,
  abbreviation: `L&D`,
  professionIds: [5, 2, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 35,
    relatedSpecialtyId: 53
  }]
}, {
  id: 36,
  name: `Lawyer`,
  abbreviation: `LGL`,
  professionIds: [24],
  specialtyRelatedSpecialties: []
}, {
  id: 37,
  name: `LTC`,
  abbreviation: `LTC`,
  professionIds: [1, 2, 5],
  specialtyRelatedSpecialties: []
}, {
  id: 42,
  name: `Medical Surgical`,
  abbreviation: `MS`,
  professionIds: [5, 2, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 42,
    relatedSpecialtyId: 174
  }, {
    specialtyId: 42,
    relatedSpecialtyId: 238
  }, {
    specialtyId: 42,
    relatedSpecialtyId: 239
  }, {
    specialtyId: 42,
    relatedSpecialtyId: 249
  }, {
    specialtyId: 42,
    relatedSpecialtyId: 254
  }, {
    specialtyId: 42,
    relatedSpecialtyId: 260
  }, {
    specialtyId: 42,
    relatedSpecialtyId: 261
  }, {
    specialtyId: 42,
    relatedSpecialtyId: 262
  }, {
    specialtyId: 42,
    relatedSpecialtyId: 265
  }, {
    specialtyId: 42,
    relatedSpecialtyId: 289
  }, {
    specialtyId: 42,
    relatedSpecialtyId: 295
  }]
}, {
  id: 49,
  name: `NICU`,
  abbreviation: `NICU`,
  professionIds: [1, 2, 5],
  specialtyRelatedSpecialties: [{
    specialtyId: 49,
    relatedSpecialtyId: 162
  }]
}, {
  id: 51,
  name: `Mother-Baby / Couplet Care / Post Partum`,
  abbreviation: `MB/PP`,
  professionIds: [5, 2, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 51,
    relatedSpecialtyId: 53
  }]
}, {
  id: 53,
  name: `OB/GYN`,
  abbreviation: `OBGYN`,
  professionIds: [1, 2, 5],
  specialtyRelatedSpecialties: [{
    specialtyId: 53,
    relatedSpecialtyId: 35
  }, {
    specialtyId: 53,
    relatedSpecialtyId: 51
  }]
}, {
  id: 57,
  name: `Operating Room`,
  abbreviation: `OR`,
  professionIds: [5, 2, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 57,
    relatedSpecialtyId: 293
  }, {
    specialtyId: 57,
    relatedSpecialtyId: 316
  }]
}, {
  id: 60,
  name: `PACU`,
  abbreviation: `PACU`,
  professionIds: [1, 2, 5],
  specialtyRelatedSpecialties: [{
    specialtyId: 60,
    relatedSpecialtyId: 316
  }]
}, {
  id: 61,
  name: `Pediatrics`,
  abbreviation: `PEDS`,
  professionIds: [5, 2, 16, 15, 26, 25, 17, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 61,
    relatedSpecialtyId: 237
  }, {
    specialtyId: 61,
    relatedSpecialtyId: 290
  }]
}, {
  id: 65,
  name: `Behavioral Health`,
  abbreviation: `BH`,
  professionIds: [1, 2, 5],
  specialtyRelatedSpecialties: []
}, {
  id: 80,
  name: `Telemetry`,
  abbreviation: `TELE`,
  professionIds: [5, 2, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 80,
    relatedSpecialtyId: 227
  }, {
    specialtyId: 80,
    relatedSpecialtyId: 230
  }, {
    specialtyId: 80,
    relatedSpecialtyId: 244
  }, {
    specialtyId: 80,
    relatedSpecialtyId: 245
  }, {
    specialtyId: 80,
    relatedSpecialtyId: 289
  }, {
    specialtyId: 80,
    relatedSpecialtyId: 291
  }, {
    specialtyId: 80,
    relatedSpecialtyId: 311
  }]
}, {
  id: 86,
  name: `BICU`,
  abbreviation: `BICU`,
  professionIds: [1, 2, 5],
  specialtyRelatedSpecialties: [{
    specialtyId: 86,
    relatedSpecialtyId: 16
  }]
}, {
  id: 112,
  name: `Cath Lab`,
  abbreviation: `CTHLAB`,
  professionIds: [5, 2, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 112,
    relatedSpecialtyId: 294
  }]
}, {
  id: 114,
  name: `Cath Lab Tech`,
  abbreviation: `CCTECH`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 115,
  name: `CT Tech`,
  abbreviation: `CTTECH`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 116,
  name: `Echo Tech`,
  abbreviation: `ECHOC`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 117,
  name: `General X-Ray`,
  abbreviation: `GENXRY`,
  professionIds: [],
  specialtyRelatedSpecialties: []
}, {
  id: 118,
  name: `MRI Tech`,
  abbreviation: `MRI`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 119,
  name: `Mammography Tech`,
  abbreviation: `MMOTECH`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 120,
  name: `Nuclear Medical Tech`,
  abbreviation: `NMT`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 121,
  name: `Radiation Therapist`,
  abbreviation: `RAD-TH`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 122,
  name: `Vascular Tech`,
  abbreviation: `VAS-TECH`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 123,
  name: `Special Procedures`,
  abbreviation: `SP`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 124,
  name: `Ultrasound Tech`,
  abbreviation: `ULT`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 125,
  name: `Interventional Radiology`,
  abbreviation: `IVRAD`,
  professionIds: [],
  specialtyRelatedSpecialties: []
}, {
  id: 130,
  name: `RRT-NICU`,
  abbreviation: `RRT-NICU`,
  professionIds: [13],
  specialtyRelatedSpecialties: []
}, {
  id: 131,
  name: `SNF`,
  abbreviation: `SNF`,
  professionIds: [17, 25, 26, 15, 16, 31],
  specialtyRelatedSpecialties: []
}, {
  id: 134,
  name: `Acute Care / Hospital`,
  abbreviation: `ACUTE`,
  professionIds: [31, 16, 15, 26, 25, 17],
  specialtyRelatedSpecialties: []
}, {
  id: 136,
  name: `In-patient Rehab`,
  abbreviation: `IN-RHB`,
  professionIds: [17, 25, 26, 15, 16, 31],
  specialtyRelatedSpecialties: []
}, {
  id: 137,
  name: `Outpatient`,
  abbreviation: `OUTP`,
  professionIds: [31, 16, 15, 26, 25, 17],
  specialtyRelatedSpecialties: []
}, {
  id: 138,
  name: `Audiologist`,
  abbreviation: `AUD`,
  professionIds: [15, 31, 46],
  specialtyRelatedSpecialties: []
}, {
  id: 140,
  name: `Pediatrics / Schools`,
  abbreviation: `PEDS/Sch`,
  professionIds: [31, 15, 16, 17, 25, 26],
  specialtyRelatedSpecialties: []
}, {
  id: 143,
  name: `Manager / Supervisor`,
  abbreviation: `MGR`,
  professionIds: [26, 25, 17, 16, 15],
  specialtyRelatedSpecialties: []
}, {
  id: 146,
  name: `Behavioral Health`,
  abbreviation: `BH`,
  professionIds: [15, 16, 17, 25, 26, 31],
  specialtyRelatedSpecialties: []
}, {
  id: 153,
  name: `Pharmacist Inpatient`,
  abbreviation: `PHARM-INP`,
  professionIds: [20],
  specialtyRelatedSpecialties: []
}, {
  id: 154,
  name: `GI Lab`,
  abbreviation: `GI`,
  professionIds: [2, 5, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 154,
    relatedSpecialtyId: 234
  }]
}, {
  id: 158,
  name: `Ambulatory Care`,
  abbreviation: `AMB`,
  professionIds: [1, 5, 2],
  specialtyRelatedSpecialties: []
}, {
  id: 161,
  name: `Correctional`,
  abbreviation: `CORR`,
  professionIds: [2, 5, 1],
  specialtyRelatedSpecialties: []
}, {
  id: 162,
  name: `Nursery`,
  abbreviation: `NRSRY`,
  professionIds: [1, 5, 2],
  specialtyRelatedSpecialties: [{
    specialtyId: 162,
    relatedSpecialtyId: 49
  }]
}, {
  id: 163,
  name: `PICU`,
  abbreviation: `PICU`,
  professionIds: [2, 5, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 163,
    relatedSpecialtyId: 290
  }, {
    specialtyId: 163,
    relatedSpecialtyId: 314
  }]
}, {
  id: 164,
  name: `CVOR Tech`,
  abbreviation: `CV`,
  professionIds: [69],
  specialtyRelatedSpecialties: []
}, {
  id: 173,
  name: `Hospice`,
  abbreviation: `HOSPC`,
  professionIds: [1, 5, 2],
  specialtyRelatedSpecialties: []
}, {
  id: 174,
  name: `Oncology`,
  abbreviation: `ONC`,
  professionIds: [2, 5, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 174,
    relatedSpecialtyId: 237
  }, {
    specialtyId: 174,
    relatedSpecialtyId: 238
  }, {
    specialtyId: 174,
    relatedSpecialtyId: 258
  }, {
    specialtyId: 174,
    relatedSpecialtyId: 261
  }]
}, {
  id: 176,
  name: `Cath Lab Manager`,
  abbreviation: `CATHLBMGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 177,
  name: `CICU Manager`,
  abbreviation: `CICU-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 178,
  name: `ED Manager`,
  abbreviation: `ED-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 179,
  name: `ER Manager`,
  abbreviation: `ER-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 180,
  name: `Home Health Manager`,
  abbreviation: `HH-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 181,
  name: `Hospice Manager`,
  abbreviation: `HOSPC-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 182,
  name: `ICU Manager`,
  abbreviation: `ICU-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 183,
  name: `Labor and Delivery Manager`,
  abbreviation: `L&D-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 184,
  name: `Med-Surg Manager`,
  abbreviation: `MS-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 185,
  name: `Neuro-ICU Manager`,
  abbreviation: `NEUROICU-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 186,
  name: `NICU Manager`,
  abbreviation: `NICU-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 187,
  name: `OB Manager`,
  abbreviation: `OB-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 188,
  name: `Oncology Manager`,
  abbreviation: `ONC-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 189,
  name: `OR Manager`,
  abbreviation: `OR-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 190,
  name: `Pediatrics Manager`,
  abbreviation: `PEDS-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 191,
  name: `PICU Manager`,
  abbreviation: `PICU-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 192,
  name: `SICU Manager`,
  abbreviation: `SICU-MGR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 193,
  name: `Director of ICU`,
  abbreviation: `ICU-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 194,
  name: `Director of Case Management`,
  abbreviation: `CM-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 195,
  name: `Director of CICU`,
  abbreviation: `CICU-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 196,
  name: `Director of Home Health`,
  abbreviation: `HH-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 197,
  name: `Director of Hospice Services`,
  abbreviation: `HOSPC-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 198,
  name: `Director of Human Resources`,
  abbreviation: `HR-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 199,
  name: `Director of Labor and Delivery`,
  abbreviation: `L&D-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 200,
  name: `Director of Maternal Services`,
  abbreviation: `MTNRL-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 201,
  name: `Director of Med-Surg`,
  abbreviation: `MS-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 202,
  name: `Director of Obstetrics`,
  abbreviation: `OB-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 203,
  name: `Director of Oncology`,
  abbreviation: `ONC-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 204,
  name: `Director of Pediatrics`,
  abbreviation: `PEDS-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 205,
  name: `Director of Recruiting`,
  abbreviation: `RECR-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 206,
  name: `Director of SICU`,
  abbreviation: `SICU-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 207,
  name: `Director of the Cath Lab`,
  abbreviation: `CATHL-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 208,
  name: `Director of the ED`,
  abbreviation: `ED-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 209,
  name: `Director of the ER`,
  abbreviation: `ER-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 210,
  name: `Director of the NICU`,
  abbreviation: `NICU-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 211,
  name: `Director of the PICU`,
  abbreviation: `PICU-DR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 212,
  name: `Director of Women's Services`,
  abbreviation: `WMNSVC-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 213,
  name: `ADON or Assistant Director of Nursing`,
  abbreviation: `ADON`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 214,
  name: `CEO`,
  abbreviation: `CEO`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 215,
  name: `CFO`,
  abbreviation: `CFO`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 216,
  name: `CNO or Chief Nursing Officer`,
  abbreviation: `CNO`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 217,
  name: `DON or Director of Nursing`,
  abbreviation: `DON`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 218,
  name: `Vice President`,
  abbreviation: `VP`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 219,
  name: `Vice President of Human Resources`,
  abbreviation: `VPHR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 220,
  name: `Vice President of Patient Services`,
  abbreviation: `VP-PS`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 221,
  name: `General`,
  abbreviation: `GEN`,
  professionIds: [],
  specialtyRelatedSpecialties: []
}, {
  id: 222,
  name: `RRT`,
  abbreviation: `RRT`,
  professionIds: [13],
  specialtyRelatedSpecialties: []
}, {
  id: 223,
  name: `CRT`,
  abbreviation: `CRT`,
  professionIds: [13],
  specialtyRelatedSpecialties: []
}, {
  id: 225,
  name: `PT`,
  abbreviation: `PT`,
  professionIds: [17],
  specialtyRelatedSpecialties: []
}, {
  id: 226,
  name: `Anesthetist`,
  abbreviation: `ANESTH`,
  professionIds: [1, 2, 5],
  specialtyRelatedSpecialties: []
}, {
  id: 227,
  name: `IMC`,
  abbreviation: `IMC`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 227,
    relatedSpecialtyId: 80
  }, {
    specialtyId: 227,
    relatedSpecialtyId: 230
  }, {
    specialtyId: 227,
    relatedSpecialtyId: 244
  }, {
    specialtyId: 227,
    relatedSpecialtyId: 245
  }, {
    specialtyId: 227,
    relatedSpecialtyId: 291
  }, {
    specialtyId: 227,
    relatedSpecialtyId: 317
  }]
}, {
  id: 230,
  name: `MS/Tele`,
  abbreviation: `MS/TELE`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 230,
    relatedSpecialtyId: 42
  }, {
    specialtyId: 230,
    relatedSpecialtyId: 80
  }, {
    specialtyId: 230,
    relatedSpecialtyId: 289
  }, {
    specialtyId: 230,
    relatedSpecialtyId: 291
  }]
}, {
  id: 232,
  name: `CVOR`,
  abbreviation: `CVOR`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 233,
  name: `Interventional Radiology`,
  abbreviation: `IV-RAD`,
  professionIds: [1, 12],
  specialtyRelatedSpecialties: [{
    specialtyId: 233,
    relatedSpecialtyId: 240
  }]
}, {
  id: 234,
  name: `Endoscopy`,
  abbreviation: `ENDO`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 234,
    relatedSpecialtyId: 154
  }]
}, {
  id: 235,
  name: `New Graduate`,
  abbreviation: `NEWGRAD`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 236,
  name: `Peds ER`,
  abbreviation: `PEDS-ER`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 236,
    relatedSpecialtyId: 22
  }]
}, {
  id: 237,
  name: `Pediatric Oncology`,
  abbreviation: `PEDS-ONC`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 237,
    relatedSpecialtyId: 61
  }, {
    specialtyId: 237,
    relatedSpecialtyId: 174
  }]
}, {
  id: 238,
  name: `Oncology Clinic`,
  abbreviation: `ONC-CLNC`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 238,
    relatedSpecialtyId: 174
  }, {
    specialtyId: 238,
    relatedSpecialtyId: 237
  }, {
    specialtyId: 238,
    relatedSpecialtyId: 262
  }]
}, {
  id: 239,
  name: `Urgent Care`,
  abbreviation: `URGNT`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 239,
    relatedSpecialtyId: 262
  }]
}, {
  id: 240,
  name: `Radiology`,
  abbreviation: `RAD`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 240,
    relatedSpecialtyId: 233
  }]
}, {
  id: 241,
  name: `RNFA`,
  abbreviation: `RNFA`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 241,
    relatedSpecialtyId: 57
  }]
}, {
  id: 243,
  name: `BMT`,
  abbreviation: `BMT`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 244,
  name: `Step down`,
  abbreviation: `STEP`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 244,
    relatedSpecialtyId: 80
  }, {
    specialtyId: 244,
    relatedSpecialtyId: 227
  }, {
    specialtyId: 244,
    relatedSpecialtyId: 245
  }, {
    specialtyId: 244,
    relatedSpecialtyId: 290
  }, {
    specialtyId: 244,
    relatedSpecialtyId: 291
  }]
}, {
  id: 245,
  name: `PCU`,
  abbreviation: `PCU`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 245,
    relatedSpecialtyId: 80
  }, {
    specialtyId: 245,
    relatedSpecialtyId: 227
  }, {
    specialtyId: 245,
    relatedSpecialtyId: 244
  }, {
    specialtyId: 245,
    relatedSpecialtyId: 291
  }]
}, {
  id: 246,
  name: `Skilled Nursing`,
  abbreviation: `SN`,
  professionIds: [],
  specialtyRelatedSpecialties: []
}, {
  id: 247,
  name: `Mental Health`,
  abbreviation: `MENHLTH`,
  professionIds: [29],
  specialtyRelatedSpecialties: []
}, {
  id: 248,
  name: `Behavioral Health Tech`,
  abbreviation: `BHT`,
  professionIds: [30],
  specialtyRelatedSpecialties: []
}, {
  id: 249,
  name: `Rehab`,
  abbreviation: `REHAB`,
  professionIds: [1, 5],
  specialtyRelatedSpecialties: [{
    specialtyId: 249,
    relatedSpecialtyId: 42
  }]
}, {
  id: 250,
  name: `Director of Rehab`,
  abbreviation: `REHAB-DIR`,
  professionIds: [23],
  specialtyRelatedSpecialties: []
}, {
  id: 251,
  name: `Occupational Health`,
  abbreviation: `OH`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 252,
  name: `Antepartum`,
  abbreviation: `ANTEP`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 253,
  name: `Apheresis`,
  abbreviation: `APHR`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 254,
  name: `Bariatrics`,
  abbreviation: `BAR`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 254,
    relatedSpecialtyId: 42
  }]
}, {
  id: 255,
  name: `Clinical Education Specialist`,
  abbreviation: `CES`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 256,
  name: `Educator`,
  abbreviation: `EDU`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 257,
  name: `Infection Prevention`,
  abbreviation: `INFPV`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 258,
  name: `Infusion`,
  abbreviation: `INFUS`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 258,
    relatedSpecialtyId: 174
  }, {
    specialtyId: 258,
    relatedSpecialtyId: 259
  }]
}, {
  id: 259,
  name: `IV Therapy`,
  abbreviation: `IV-THER`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 259,
    relatedSpecialtyId: 19
  }, {
    specialtyId: 259,
    relatedSpecialtyId: 258
  }]
}, {
  id: 260,
  name: `School`,
  abbreviation: `SCHOOL`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 261,
  name: `Oncology Chemo Certified`,
  abbreviation: `ONC-CHEM`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 261,
    relatedSpecialtyId: 174
  }, {
    specialtyId: 261,
    relatedSpecialtyId: 237
  }]
}, {
  id: 262,
  name: `Outpatient Clinic`,
  abbreviation: `OUTP-CLNC`,
  professionIds: [1, 2],
  specialtyRelatedSpecialties: [{
    specialtyId: 262,
    relatedSpecialtyId: 238
  }, {
    specialtyId: 262,
    relatedSpecialtyId: 239
  }]
}, {
  id: 263,
  name: `Telephone Triage/Call Center`,
  abbreviation: `TRIAGE`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 264,
  name: `Utilization Review`,
  abbreviation: `UTILRV`,
  professionIds: [1, 2, 55],
  specialtyRelatedSpecialties: [{
    specialtyId: 264,
    relatedSpecialtyId: 9
  }]
}, {
  id: 265,
  name: `Wound Care`,
  abbreviation: `WOUND`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 266,
  name: `Pharmacy Tech Inpatient`,
  abbreviation: `PhrmTech-Inp`,
  professionIds: [20],
  specialtyRelatedSpecialties: []
}, {
  id: 267,
  name: `Hand Therapy`,
  abbreviation: `HAND-THER`,
  professionIds: [17, 26, 25, 16, 15, 31],
  specialtyRelatedSpecialties: []
}, {
  id: 268,
  name: `Dosimetrist`,
  abbreviation: `DOSI`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 269,
  name: `X-Ray Tech`,
  abbreviation: `XRY-TECH`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 270,
  name: `Certified OR Tech / Surgical Tech (CST)`,
  abbreviation: `OR-TECH`,
  professionIds: [69],
  specialtyRelatedSpecialties: []
}, {
  id: 271,
  name: `OR Tech First Assist (CSFA)`,
  abbreviation: `CSFA`,
  professionIds: [69],
  specialtyRelatedSpecialties: []
}, {
  id: 272,
  name: `Manager`,
  abbreviation: `MGR`,
  professionIds: [2, 5, 1],
  specialtyRelatedSpecialties: [{
    specialtyId: 272,
    relatedSpecialtyId: 274
  }]
}, {
  id: 273,
  name: `Director`,
  abbreviation: `DIR`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 274,
  name: `House Supervisor`,
  abbreviation: `SUP`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 274,
    relatedSpecialtyId: 272
  }]
}, {
  id: 275,
  name: `Neuro ICU`,
  abbreviation: `NEURO-ICU`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 275,
    relatedSpecialtyId: 16
  }]
}, {
  id: 276,
  name: `CCU`,
  abbreviation: `CCU`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 276,
    relatedSpecialtyId: 8
  }, {
    specialtyId: 276,
    relatedSpecialtyId: 16
  }]
}, {
  id: 277,
  name: `SICU`,
  abbreviation: `SICU`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 277,
    relatedSpecialtyId: 16
  }]
}, {
  id: 278,
  name: `LCSW (Licensed Clinical Social Worker)`,
  abbreviation: `LCSW`,
  professionIds: [29],
  specialtyRelatedSpecialties: []
}, {
  id: 279,
  name: `CSW (Certified Social Worker)`,
  abbreviation: `CSW`,
  professionIds: [29],
  specialtyRelatedSpecialties: []
}, {
  id: 280,
  name: `Sterile Processing Tech (SPT)`,
  abbreviation: `STERILE-TECH`,
  professionIds: [69],
  specialtyRelatedSpecialties: []
}, {
  id: 281,
  name: `LTAC`,
  abbreviation: `LTAC`,
  professionIds: [31, 1, 15, 16, 25, 26, 17, 5],
  specialtyRelatedSpecialties: []
}, {
  id: 282,
  name: `Monitor Tech`,
  abbreviation: `MON-TECH`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 283,
  name: `Phlebotomist`,
  abbreviation: `PHLEB`,
  professionIds: [64],
  specialtyRelatedSpecialties: []
}, {
  id: 284,
  name: `Sonographer`,
  abbreviation: `SONOG`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 285,
  name: `Dialysis Tech`,
  abbreviation: `DIAL-TECH`,
  professionIds: [37],
  specialtyRelatedSpecialties: []
}, {
  id: 287,
  name: `Medical Social Worker`,
  abbreviation: `MED-SW`,
  professionIds: [29],
  specialtyRelatedSpecialties: []
}, {
  id: 288,
  name: `Open Heart`,
  abbreviation: `CVOR`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 289,
  name: `Sub-Acute`,
  abbreviation: `SUB-ACUTE`,
  professionIds: [1, 2],
  specialtyRelatedSpecialties: [{
    specialtyId: 289,
    relatedSpecialtyId: 37
  }, {
    specialtyId: 289,
    relatedSpecialtyId: 42
  }, {
    specialtyId: 289,
    relatedSpecialtyId: 230
  }, {
    specialtyId: 289,
    relatedSpecialtyId: 291
  }]
}, {
  id: 290,
  name: `Pediatric Step-Down`,
  abbreviation: `PEDS-STEP`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 291,
  name: `TCU`,
  abbreviation: `TCU`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 291,
    relatedSpecialtyId: 80
  }, {
    specialtyId: 291,
    relatedSpecialtyId: 227
  }, {
    specialtyId: 291,
    relatedSpecialtyId: 230
  }, {
    specialtyId: 291,
    relatedSpecialtyId: 244
  }, {
    specialtyId: 291,
    relatedSpecialtyId: 245
  }]
}, {
  id: 292,
  name: `Cardio Thoracic ICU`,
  abbreviation: `CT-ICU`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 293,
  name: `Peds OR`,
  abbreviation: `PEDS-OR`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 293,
    relatedSpecialtyId: 57
  }]
}, {
  id: 294,
  name: `EP Lab`,
  abbreviation: `EP-LAB`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 294,
    relatedSpecialtyId: 112
  }]
}, {
  id: 295,
  name: `Ortho`,
  abbreviation: `ORTHO`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 295,
    relatedSpecialtyId: 42
  }]
}, {
  id: 296,
  name: `PICC`,
  abbreviation: `PICC`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 298,
  name: `Certified Anesthesia Technician`,
  abbreviation: `ANEST-TECH`,
  professionIds: [39],
  specialtyRelatedSpecialties: []
}, {
  id: 299,
  name: `Medical Coder`,
  abbreviation: `MED-COD`,
  professionIds: [40],
  specialtyRelatedSpecialties: []
}, {
  id: 300,
  name: `Pathology Assistant`,
  abbreviation: `PATH-ASST`,
  professionIds: [64],
  specialtyRelatedSpecialties: []
}, {
  id: 301,
  name: `MHT`,
  abbreviation: `MHT`,
  professionIds: [42],
  specialtyRelatedSpecialties: []
}, {
  id: 302,
  name: `Paramedic`,
  abbreviation: `PARAM`,
  professionIds: [43],
  specialtyRelatedSpecialties: []
}, {
  id: 303,
  name: `Electrophysiology Tech`,
  abbreviation: `EP-TECH`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 304,
  name: `Medical Assistant`,
  abbreviation: `MED-ASST`,
  professionIds: [65],
  specialtyRelatedSpecialties: []
}, {
  id: 306,
  name: `Clinical Psychologist`,
  abbreviation: `CLN-PSYCH`,
  professionIds: [47],
  specialtyRelatedSpecialties: []
}, {
  id: 308,
  name: `Histology Tech`,
  abbreviation: `HST-TCH`,
  professionIds: [64],
  specialtyRelatedSpecialties: []
}, {
  id: 309,
  name: `Trained Medication Assistant`,
  abbreviation: `MEDC-ASST`,
  professionIds: [49],
  specialtyRelatedSpecialties: []
}, {
  id: 310,
  name: `Chemo`,
  abbreviation: `CHEMO`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 311,
  name: `Clinical Decisions`,
  abbreviation: `CDU`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 311,
    relatedSpecialtyId: 22
  }, {
    specialtyId: 311,
    relatedSpecialtyId: 80
  }]
}, {
  id: 312,
  name: `Medical Technologist`,
  abbreviation: `MT`,
  professionIds: [64],
  specialtyRelatedSpecialties: []
}, {
  id: 313,
  name: `Medical Lab Technician`,
  abbreviation: `MLT`,
  professionIds: [64],
  specialtyRelatedSpecialties: []
}, {
  id: 314,
  name: `CVPICU`,
  abbreviation: `CVPICU`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 314,
    relatedSpecialtyId: 8
  }, {
    specialtyId: 314,
    relatedSpecialtyId: 163
  }]
}, {
  id: 315,
  name: `MICU`,
  abbreviation: `MICU`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 315,
    relatedSpecialtyId: 16
  }]
}, {
  id: 316,
  name: `Outpatient Surgery`,
  abbreviation: `OUTPSURG`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 317,
  name: `DOU`,
  abbreviation: `DOU`,
  professionIds: [1],
  specialtyRelatedSpecialties: [{
    specialtyId: 317,
    relatedSpecialtyId: 227
  }]
}, {
  id: 319,
  name: `Trauma ICU`,
  abbreviation: `TRAUMAICU`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 320,
  name: `Analyst`,
  abbreviation: `ANALYST`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 321,
  name: `Business Analyst`,
  abbreviation: `BUSANLST`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 322,
  name: `Claims Processor`,
  abbreviation: `CLAIMS`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 323,
  name: `Clerical`,
  abbreviation: `CLERK`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 324,
  name: `Coding Compliance Coordinator`,
  abbreviation: `CODCOMP`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 325,
  name: `Customer Service`,
  abbreviation: `CUSTSERV`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 326,
  name: `Collections`,
  abbreviation: `COLL`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 327,
  name: `Environmental Services`,
  abbreviation: `ENVSERV`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 328,
  name: `Environmental Worker`,
  abbreviation: `ENVWRK`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 329,
  name: `Help Desk`,
  abbreviation: `HELP`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 330,
  name: `Housekeeper`,
  abbreviation: `HOUSE`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 331,
  name: `IT`,
  abbreviation: `IT`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 332,
  name: `Patient Access Coordinator`,
  abbreviation: `PATACC`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 333,
  name: `Patient Accounting`,
  abbreviation: `PATACCT`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 334,
  name: `Patient Financial Services`,
  abbreviation: `PATFINSERV`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 335,
  name: `Payroll`,
  abbreviation: `PAYROLL`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 336,
  name: `PBX Operator`,
  abbreviation: `PBX`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 337,
  name: `Phone Console Operator`,
  abbreviation: `PHONE`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 338,
  name: `Reimbursement Specialist`,
  abbreviation: `REIMB`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 339,
  name: `Scheduling Coordinator`,
  abbreviation: `SCHED`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 340,
  name: `Security Guard`,
  abbreviation: `SECUR`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 341,
  name: `Short Stay`,
  abbreviation: `SHORT`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 342,
  name: `Senior Management Analyst`,
  abbreviation: `SRMGMANLST`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 343,
  name: `Staff Accountant`,
  abbreviation: `STAFFACCT`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 344,
  name: `Support Specialist`,
  abbreviation: `SUPPORT`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 345,
  name: `Surgical Prep`,
  abbreviation: `SURGPREP`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 346,
  name: `Systems Analyst`,
  abbreviation: `SYSANLST`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 347,
  name: `Technician`,
  abbreviation: `TECH`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 348,
  name: `Technologist`,
  abbreviation: `TECHNLG`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 350,
  name: `GI Tech`,
  abbreviation: `GI-TECH`,
  professionIds: [69],
  specialtyRelatedSpecialties: []
}, {
  id: 353,
  name: `Coder`,
  abbreviation: `CODER`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 354,
  name: `PreOp`,
  abbreviation: `PreOp`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 357,
  name: `Radiation Oncology`,
  abbreviation: `RADONC`,
  professionIds: [1, 56],
  specialtyRelatedSpecialties: []
}, {
  id: 358,
  name: `OB Tech`,
  abbreviation: `OBTECH`,
  professionIds: [69],
  specialtyRelatedSpecialties: []
}, {
  id: 359,
  name: `Patient Care Technician`,
  abbreviation: `PCTECH`,
  professionIds: [57],
  specialtyRelatedSpecialties: []
}, {
  id: 360,
  name: `Patient Transporter`,
  abbreviation: `TRANSPORT`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 362,
  name: `Clinical Lab Scientist`,
  abbreviation: `CLS`,
  professionIds: [64],
  specialtyRelatedSpecialties: []
}, {
  id: 363,
  name: `Psychiatrist`,
  abbreviation: `MD-PSYCH`,
  professionIds: [59],
  specialtyRelatedSpecialties: []
}, {
  id: 364,
  name: `Human Resources Assistant`,
  abbreviation: `HRASST`,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 365,
  name: `Radiologist`,
  abbreviation: `MD-RAD`,
  professionIds: [59],
  specialtyRelatedSpecialties: []
}, {
  id: 366,
  name: `Instrument Tech`,
  abbreviation: `INST-TECH`,
  professionIds: [69],
  specialtyRelatedSpecialties: []
}, {
  id: 367,
  name: `Patient Registrar`,
  abbreviation: `PAT-REG`,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 368,
  name: `Exercise Physiologist`,
  abbreviation: `EXERPHS`,
  professionIds: [61],
  specialtyRelatedSpecialties: []
}, {
  id: 369,
  name: `Athletic Trainer`,
  abbreviation: `ATH-TRN`,
  professionIds: [61],
  specialtyRelatedSpecialties: []
}, {
  id: 370,
  name: `Kinesiotherapist`,
  abbreviation: `KIN-THER`,
  professionIds: [61],
  specialtyRelatedSpecialties: []
}, {
  id: 376,
  name: `Referral Coordinator`,
  abbreviation: `REFCOORD`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 377,
  name: `Case Management Assistant`,
  abbreviation: `CMASST`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 378,
  name: `Ophthalmologist`,
  abbreviation: `OPTH`,
  professionIds: [62],
  specialtyRelatedSpecialties: []
}, {
  id: 379,
  name: `Optometrist`,
  abbreviation: `OPT`,
  professionIds: [62],
  specialtyRelatedSpecialties: []
}, {
  id: 380,
  name: `Optician`,
  abbreviation: `OPTC`,
  professionIds: [62],
  specialtyRelatedSpecialties: []
}, {
  id: 381,
  name: `Ophthalmic Technician`,
  abbreviation: `OPTH-TECH`,
  professionIds: [62],
  specialtyRelatedSpecialties: []
}, {
  id: 382,
  name: `Accounts Payable`,
  abbreviation: `AP`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 383,
  name: `Credentialing Specialist`,
  abbreviation: `CS`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 384,
  name: `Perfusionist`,
  abbreviation: `PERF`,
  professionIds: [63],
  specialtyRelatedSpecialties: []
}, {
  id: 385,
  name: `Polysomnographer / Sleep Tech`,
  abbreviation: `POLY-SLEEP`,
  professionIds: [13],
  specialtyRelatedSpecialties: []
}, {
  id: 386,
  name: `EEG Tech`,
  abbreviation: `EEG`,
  professionIds: [13, 12],
  specialtyRelatedSpecialties: []
}, {
  id: 387,
  name: `EKG Tech`,
  abbreviation: `EKG`,
  professionIds: [12],
  specialtyRelatedSpecialties: []
}, {
  id: 388,
  name: `Hematology`,
  abbreviation: `HEM`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 390,
  name: `Cyto Tech`,
  abbreviation: `CYTO-TCH`,
  professionIds: [64],
  specialtyRelatedSpecialties: []
}, {
  id: 391,
  name: `ER Holding`,
  abbreviation: `ERHOLD`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 392,
  name: `Medical Surgical - Neuro`,
  abbreviation: `MS-NEUR`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 393,
  name: `Accounts Receivable`,
  abbreviation: `AR`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 394,
  name: `Microbiology Tech`,
  abbreviation: `MICROB-TECH`,
  professionIds: [64],
  specialtyRelatedSpecialties: []
}, {
  id: 395,
  name: `Pain Management`,
  abbreviation: `PAIN`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 396,
  name: `Discharge Planner`,
  abbreviation: `Dischg Planner`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 397,
  name: `Sitter`,
  abbreviation: `SITTER`,
  professionIds: [66],
  specialtyRelatedSpecialties: []
}, {
  id: 398,
  name: `Transplant Coordinator`,
  abbreviation: `TRNSPLT-COORD`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 399,
  name: `Nurse Navigator`,
  abbreviation: `NAVIGATOR`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 400,
  name: `Certified Child Life Specialist`,
  abbreviation: `Child Life Spec`,
  professionIds: [67],
  specialtyRelatedSpecialties: []
}, {
  id: 401,
  name: `Management Specialist`,
  abbreviation: `MGSP`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 402,
  name: `Recruiter`,
  abbreviation: `RECR`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 403,
  name: `Behavioral Health Assistant`,
  abbreviation: `BHA`,
  professionIds: [68],
  specialtyRelatedSpecialties: []
}, {
  id: 404,
  name: `OR Tech / Surgical Tech`,
  abbreviation: `ORT`,
  professionIds: [69],
  specialtyRelatedSpecialties: []
}, {
  id: 405,
  name: `Allergy and Immunology`,
  abbreviation: `PHYS`,
  professionIds: [72, 59, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 406,
  name: `Anesthesiology`,
  abbreviation: `PHYS`,
  professionIds: [59],
  specialtyRelatedSpecialties: []
}, {
  id: 407,
  name: `Cardiology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 408,
  name: `Cardiothoracic Surgery`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 409,
  name: `Cardiovascular Surgery`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 410,
  name: `Colon and Rectal Surgery`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 411,
  name: `Correctional Medicine`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 412,
  name: `Critical Care`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 413,
  name: `Dermatology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 414,
  name: `Endocrinology`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 415,
  name: `Emergency Medicine FP/IM`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 416,
  name: `Family Practice`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 417,
  name: `Gastroenterology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 418,
  name: `General Practice`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 419,
  name: `General Surgery`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 420,
  name: `Geriatrics`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 421,
  name: `Gynecological Oncology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 422,
  name: `Hematology/Oncology`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 423,
  name: `Hospice/Palliative Care`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 424,
  name: `Hospitalist`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 425,
  name: `Hospitalist-OB`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 426,
  name: `Hospitalist-Neuro`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 427,
  name: `Infectious Disease`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 428,
  name: `Internal Medicine`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 429,
  name: `Interventional Radiology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 430,
  name: `Maternal Fetal Medicine`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 431,
  name: `Medical Surgical`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 432,
  name: `Mother Baby`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 433,
  name: `Neonatology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 434,
  name: `Nephrology`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 435,
  name: `Neurology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 436,
  name: `Neurosurgery`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 437,
  name: `Obstetrics/Gynecology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 438,
  name: `Occupational Medicine`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 439,
  name: `Oncology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 440,
  name: `Ophthalmology`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 441,
  name: `Orthopedics`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 442,
  name: `Orthopedic Surgery`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 443,
  name: `Orthopedic Trauma Surgery`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 444,
  name: `Otorhinolaryngology (ENT)`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 446,
  name: `Pain Management`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 447,
  name: `Palliative Care`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 448,
  name: `Pathology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 449,
  name: `Pediatrics`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 450,
  name: `Pediatric Emergency Medicine`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 451,
  name: `Pediatric Hospitalist`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 452,
  name: `Pediatric Neurology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 453,
  name: `Physical Medicine Rehabilitation`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 454,
  name: `Primary Care Family Practice`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 456,
  name: `Pulmonology`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 457,
  name: `Pulmonary Cardiac Care`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 458,
  name: `Radiation Oncology`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 459,
  name: `Radiology`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 460,
  name: `Rheumatology`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 461,
  name: `Sleep Medicine`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 462,
  name: `Surgery`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 463,
  name: `Surgery-Vascular`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 464,
  name: `Telemedicine`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 465,
  name: `Urgent Care`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 466,
  name: `Urology`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 467,
  name: `Womens Health`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 468,
  name: `Financial Counselor`,
  abbreviation: `FIN-COUNS`,
  professionIds: [55, 88],
  specialtyRelatedSpecialties: []
}, {
  id: 469,
  name: `Pulmonary Function Technologist`,
  abbreviation: `PULM-TECH`,
  professionIds: [13],
  specialtyRelatedSpecialties: []
}, {
  id: 470,
  name: `Underpayment Management Specialist`,
  abbreviation: `UMS`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 471,
  name: `Medical Lab Scientist`,
  abbreviation: `MLS`,
  professionIds: [64],
  specialtyRelatedSpecialties: []
}, {
  id: 472,
  name: `Cath Lab Holding`,
  abbreviation: `CATH-HOLD`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 473,
  name: `Emergency Medicine ABEM`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 474,
  name: `Psychiatry Child/Adolescent`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 475,
  name: `Primary Care Internal Medicine`,
  abbreviation: `PHYS`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 476,
  name: `Primary Care Pediatrics`,
  abbreviation: `PHYS`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 477,
  name: `Supply Clerk`,
  abbreviation: `SUPPLY`,
  professionIds: [55, 76],
  specialtyRelatedSpecialties: []
}, {
  id: 478,
  name: `Pharmacist Outpatient`,
  abbreviation: `PARM-OUTP`,
  professionIds: [20],
  specialtyRelatedSpecialties: []
}, {
  id: 479,
  name: `Food Services`,
  abbreviation: `FOOD-SVC`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 480,
  name: `Clinical Documentation Specialist`,
  abbreviation: `CL-DOC`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 481,
  name: `Purchasing Assistant`,
  abbreviation: `PURCH-ASST`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 483,
  name: `Primary Care`,
  abbreviation: `PRMRYCR`,
  professionIds: [2, 5, 1],
  specialtyRelatedSpecialties: []
}, {
  id: 484,
  name: `Midwife`,
  abbreviation: `MIDW`,
  professionIds: [71],
  specialtyRelatedSpecialties: []
}, {
  id: 485,
  name: `Dietician`,
  abbreviation: `DIET`,
  professionIds: [70],
  specialtyRelatedSpecialties: []
}, {
  id: 486,
  name: `Peds Neuro`,
  abbreviation: `PEDS-NEURO`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 487,
  name: `Peds Ortho`,
  abbreviation: `PEDS-ORTHO`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 488,
  name: `Peds Behavioral Health`,
  abbreviation: `PEDS-BH`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 489,
  name: `Peds Cath Lab`,
  abbreviation: `PEDS-CATH`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 490,
  name: `Patient Services Coordinator`,
  abbreviation: `PSC`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 491,
  name: `Certified Registered Nurse Anesthetist (CRNA)`,
  abbreviation: `CRNA`,
  professionIds: [73],
  specialtyRelatedSpecialties: []
}, {
  id: 492,
  name: `Hospitalist-Intensivist`,
  abbreviation: `HOSP-ICU`,
  professionIds: [59, 72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 493,
  name: `Hospitalist-Pediatric Intensivist`,
  abbreviation: `HOSP-PICU`,
  professionIds: [3, 72, 59],
  specialtyRelatedSpecialties: []
}, {
  id: 494,
  name: `Psychiatry`,
  abbreviation: `PSYCH`,
  professionIds: [72, 3],
  specialtyRelatedSpecialties: []
}, {
  id: 495,
  name: `ER Tech`,
  abbreviation: `ER-TECH`,
  professionIds: [74],
  specialtyRelatedSpecialties: []
}, {
  id: 496,
  name: `EVS Supervisor`,
  abbreviation: `EVS-SUP`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 497,
  name: `Department Aide`,
  abbreviation: `DEP-AIDE`,
  professionIds: [75],
  specialtyRelatedSpecialties: []
}, {
  id: 498,
  name: `Peds PACU`,
  abbreviation: `PEDS-PACU`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 499,
  name: `Peds Home Health`,
  abbreviation: `PEDS-HH`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 500,
  name: `Peds CVOR`,
  abbreviation: `PEDS-CVOR`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 501,
  name: `Peds Ambulatory Care`,
  abbreviation: `PEDS-AMB`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 502,
  name: `Executive Assistant`,
  abbreviation: `EXEC-ASST`,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 503,
  name: `Authorization Rep`,
  abbreviation: `AUTH-REP`,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 504,
  name: `Epic Credentialied Trainer`,
  abbreviation: `EPIC-TRAIN`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 505,
  name: `IS Trainer`,
  abbreviation: `IS-TRAIN`,
  professionIds: [55],
  specialtyRelatedSpecialties: []
}, {
  id: 507,
  name: `Pediatric Apheresis`,
  abbreviation: `Peds-Aph`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 508,
  name: `Patient Transporter`,
  abbreviation: `TRANSPORT`,
  professionIds: [76],
  specialtyRelatedSpecialties: []
}, {
  id: 509,
  name: `Supply Clerk`,
  abbreviation: `Supply`,
  professionIds: [],
  specialtyRelatedSpecialties: []
}, {
  id: 510,
  name: `Driver`,
  abbreviation: `Driver`,
  professionIds: [76],
  specialtyRelatedSpecialties: []
}, {
  id: 511,
  name: `Pharmacy Tech Outpatient`,
  abbreviation: `Pharm Tech`,
  professionIds: [20],
  specialtyRelatedSpecialties: []
}, {
  id: 512,
  name: `Laboratory Assistant`,
  abbreviation: `Lab Asst`,
  professionIds: [64],
  specialtyRelatedSpecialties: []
}, {
  id: 513,
  name: `Medical Transcriptionist`,
  abbreviation: `Med Transcript`,
  professionIds: [77],
  specialtyRelatedSpecialties: []
}, {
  id: 514,
  name: `Data Entry Clerk`,
  abbreviation: `DE Clerk`,
  professionIds: [77],
  specialtyRelatedSpecialties: []
}, {
  id: 515,
  name: `Credentialing Coordinator`,
  abbreviation: `Cred Coord`,
  professionIds: [77],
  specialtyRelatedSpecialties: []
}, {
  id: 516,
  name: `Patient Access Representative`,
  abbreviation: `Patient Access Rep`,
  professionIds: [77],
  specialtyRelatedSpecialties: []
}, {
  id: 517,
  name: `Health Information Manager`,
  abbreviation: `Health Info Mgr`,
  professionIds: [77],
  specialtyRelatedSpecialties: []
}, {
  id: 518,
  name: `Patient Access Manager`,
  abbreviation: `Patient Access Mgr`,
  professionIds: [77],
  specialtyRelatedSpecialties: []
}, {
  id: 519,
  name: `Network Architect`,
  abbreviation: `Net-Arch`,
  professionIds: [78],
  specialtyRelatedSpecialties: []
}, {
  id: 520,
  name: `Epic Credentialed Trainer`,
  abbreviation: `Epic-Trainer`,
  professionIds: [78],
  specialtyRelatedSpecialties: []
}, {
  id: 521,
  name: `IS Trainer`,
  abbreviation: `IS-Trainer`,
  professionIds: [78],
  specialtyRelatedSpecialties: []
}, {
  id: 522,
  name: `Data Analyst`,
  abbreviation: `Data-Analyst`,
  professionIds: [78],
  specialtyRelatedSpecialties: []
}, {
  id: 523,
  name: `Field Support Technician`,
  abbreviation: `Field Supp Tech`,
  professionIds: [78],
  specialtyRelatedSpecialties: []
}, {
  id: 524,
  name: `Programmer Analyst`,
  abbreviation: `Prog-Analyst`,
  professionIds: [78],
  specialtyRelatedSpecialties: []
}, {
  id: 525,
  name: `Paralegal`,
  abbreviation: `LGL`,
  professionIds: [24],
  specialtyRelatedSpecialties: []
}, {
  id: 526,
  name: `Legal Assistant`,
  abbreviation: `LGL`,
  professionIds: [24],
  specialtyRelatedSpecialties: []
}, {
  id: 527,
  name: `Legal Intern`,
  abbreviation: `LGL`,
  professionIds: [24],
  specialtyRelatedSpecialties: []
}, {
  id: 528,
  name: `Security Officer`,
  abbreviation: `SEC`,
  professionIds: [85],
  specialtyRelatedSpecialties: []
}, {
  id: 529,
  name: `Security Assistant`,
  abbreviation: `SEC`,
  professionIds: [85],
  specialtyRelatedSpecialties: []
}, {
  id: 530,
  name: `Marketing Analyst`,
  abbreviation: `MKTG`,
  professionIds: [84],
  specialtyRelatedSpecialties: []
}, {
  id: 531,
  name: `Marketing Coordinator`,
  abbreviation: `MKTG`,
  professionIds: [84],
  specialtyRelatedSpecialties: []
}, {
  id: 532,
  name: `Communications Coordinator`,
  abbreviation: `MKTG`,
  professionIds: [84],
  specialtyRelatedSpecialties: []
}, {
  id: 533,
  name: `Shuttle Driver`,
  abbreviation: `Driver`,
  professionIds: [76],
  specialtyRelatedSpecialties: []
}, {
  id: 535,
  name: `Hospital Assistant`,
  abbreviation: `ADMIN`,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 536,
  name: `Medical Staff Coordinator`,
  abbreviation: `ADMIN`,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 537,
  name: `Research Associate`,
  abbreviation: `ADMIN`,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 538,
  name: `Scheduler`,
  abbreviation: `ADMIN`,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 539,
  name: `Community Outreach Specialist`,
  abbreviation: `ADMIN`,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 540,
  name: `Receptionist`,
  abbreviation: `ADMIN`,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 541,
  name: `Critical Care Transport`,
  abbreviation: `CCT`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 542,
  name: `Emergency Transport Traveler`,
  abbreviation: `ETT`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 550,
  name: `Administrative Assistant`,
  abbreviation: ``,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 551,
  name: `Administrative Associate`,
  abbreviation: ``,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 552,
  name: `Customer Service Representative`,
  abbreviation: ``,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 553,
  name: `Help Desk Coordinator`,
  abbreviation: ``,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 554,
  name: `Custodian`,
  abbreviation: ``,
  professionIds: [86],
  specialtyRelatedSpecialties: []
}, {
  id: 555,
  name: `Linen Tech`,
  abbreviation: ``,
  professionIds: [86],
  specialtyRelatedSpecialties: []
}, {
  id: 556,
  name: `EVS Manager`,
  abbreviation: ``,
  professionIds: [86],
  specialtyRelatedSpecialties: []
}, {
  id: 557,
  name: `Custodial Supervisor`,
  abbreviation: ``,
  professionIds: [86],
  specialtyRelatedSpecialties: []
}, {
  id: 558,
  name: `EVS Aide`,
  abbreviation: ``,
  professionIds: [86],
  specialtyRelatedSpecialties: []
}, {
  id: 559,
  name: `Carpenter`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 560,
  name: `Electrician`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 561,
  name: `Electrician - High Voltage`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 562,
  name: `Locksmith`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 563,
  name: `Maintenance Worker`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 564,
  name: `Mechanic`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 565,
  name: `Operator`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 566,
  name: `Painter`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 567,
  name: `Plumber`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 568,
  name: `Program Analyst`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 569,
  name: `Project Manager`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 570,
  name: `Refrigeration Mechanic`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 571,
  name: `Sheetmetal Worker`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 572,
  name: `Steamfitter`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 573,
  name: `Systems Operator`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 574,
  name: `Pipefitter`,
  abbreviation: ``,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 575,
  name: `Accounts Receivable Clerk`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 576,
  name: `Collections Representative`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 577,
  name: `Patient Accountant`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 578,
  name: `Payroll Coordinator`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 579,
  name: `Senior Accountant`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 580,
  name: `Audit Manager`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 581,
  name: `Medical Billing Specialist`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 582,
  name: `Billing Specialist`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 583,
  name: `Finance Clerk`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 584,
  name: `Financial Coordinator`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 585,
  name: `Accounting Analyst`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 586,
  name: `Financial Services Manager`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 587,
  name: `Food Service Worker`,
  abbreviation: ``,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 588,
  name: `Barista`,
  abbreviation: ``,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 589,
  name: `Cashier`,
  abbreviation: ``,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 590,
  name: `Call Center Associate`,
  abbreviation: ``,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 591,
  name: `Lead Food Service Worker`,
  abbreviation: ``,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 592,
  name: `FNS Manager`,
  abbreviation: ``,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 593,
  name: `FNS Supervisor`,
  abbreviation: ``,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 594,
  name: `Cook`,
  abbreviation: ``,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 595,
  name: `Chef`,
  abbreviation: ``,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 596,
  name: `Room Service Attendant`,
  abbreviation: ``,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 597,
  name: `Storekeeper`,
  abbreviation: ``,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 598,
  name: `Human Resources Representative`,
  abbreviation: ``,
  professionIds: [90],
  specialtyRelatedSpecialties: []
}, {
  id: 599,
  name: `Benefits Analyst`,
  abbreviation: ``,
  professionIds: [90],
  specialtyRelatedSpecialties: []
}, {
  id: 600,
  name: `Retirement Plan Analyst`,
  abbreviation: ``,
  professionIds: [90],
  specialtyRelatedSpecialties: []
}, {
  id: 601,
  name: `Benefits Specialist`,
  abbreviation: ``,
  professionIds: [90],
  specialtyRelatedSpecialties: []
}, {
  id: 602,
  name: `Benefits Manager`,
  abbreviation: ``,
  professionIds: [90],
  specialtyRelatedSpecialties: []
}, {
  id: 603,
  name: `Accounts Payable Clerk`,
  abbreviation: ``,
  professionIds: [88],
  specialtyRelatedSpecialties: []
}, {
  id: 604,
  name: `Outpatient Clinic Infusion`,
  abbreviation: `OCI`,
  professionIds: [1, 2],
  specialtyRelatedSpecialties: []
}, {
  id: 605,
  name: `Outpatient Clinic Cardiology`,
  abbreviation: `OCC`,
  professionIds: [2, 1],
  specialtyRelatedSpecialties: []
}, {
  id: 606,
  name: `Outpatient Clinic Phlebotomy`,
  abbreviation: `OCP`,
  professionIds: [1, 2],
  specialtyRelatedSpecialties: []
}, {
  id: 607,
  name: `Certified Social Worker`,
  abbreviation: `CSW`,
  professionIds: [29],
  specialtyRelatedSpecialties: []
}, {
  id: 610,
  name: `Steam Engineer`,
  abbreviation: `SE`,
  professionIds: [87],
  specialtyRelatedSpecialties: []
}, {
  id: 611,
  name: `Nutrition Clerk`,
  abbreviation: `NC`,
  professionIds: [89],
  specialtyRelatedSpecialties: []
}, {
  id: 612,
  name: `Critical Care Float`,
  abbreviation: `CC Float`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 613,
  name: `PCU Float`,
  abbreviation: `PCU Float`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 614,
  name: `MS/Tele Float`,
  abbreviation: `MS/Tele Float`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 615,
  name: `Tele Float`,
  abbreviation: `Tele Float`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 616,
  name: `Purchasing Agent`,
  abbreviation: `PAGT`,
  professionIds: [60],
  specialtyRelatedSpecialties: []
}, {
  id: 617,
  name: `Quality Management`,
  abbreviation: `QM`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}, {
  id: 618,
  name: `Logistics Tech`,
  abbreviation: `LogiTech`,
  professionIds: [76],
  specialtyRelatedSpecialties: []
}, {
  id: 619,
  name: `Surgery-Trauma`,
  abbreviation: `SurgT`,
  professionIds: [59],
  specialtyRelatedSpecialties: []
}, {
  id: 620,
  name: `Graphic Designer`,
  abbreviation: `GD`,
  professionIds: [84],
  specialtyRelatedSpecialties: []
}, {
  id: 621,
  name: `Pediatric Rehab`,
  abbreviation: `Peb Rehab`,
  professionIds: [1],
  specialtyRelatedSpecialties: []
}];

export default mockSpecialties;
